/* eslint-disable */
export default {
  noActiveCalls: 'No hay llamadas activas',
  currentCall: 'Llamada actual',
  ringCall: 'Llamada sonando',
  onHoldCall: 'Llamada en espera',
  otherDeviceCall: 'Llamadas en curso en mis otros dispositivos',
  confirmation: 'Confirmación',
  confirmMergeToConference: '¿Agregar a la conferencia telefónica?',
  mergeToConference: 'Combinar',
  conferenceCall: 'Conferencia telefónica',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
